var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGroup = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5C14.3869 2.5 16.6761 3.44821 18.364 5.13604C20.0518 6.82387 21 9.11305 21 11.5C21 14.574 19.324 17.09 17.558 18.895C16.6755 19.7869 15.7128 20.5956 14.682 21.311L14.256 21.601L14.056 21.734L13.679 21.974L13.343 22.179L12.927 22.421C12.6445 22.5818 12.325 22.6663 12 22.6663C11.675 22.6663 11.3555 22.5818 11.073 22.421L10.657 22.179L10.137 21.859L9.945 21.734L9.535 21.461C8.42298 20.7083 7.38707 19.8489 6.442 18.895C4.676 17.089 3 14.574 3 11.5C3 9.11305 3.94821 6.82387 5.63604 5.13604C7.32387 3.44821 9.61305 2.5 12 2.5ZM12 8.5C11.606 8.5 11.2159 8.5776 10.8519 8.72836C10.488 8.87913 10.1573 9.1001 9.87868 9.37868C9.6001 9.65726 9.37913 9.98797 9.22836 10.3519C9.0776 10.7159 9 11.106 9 11.5C9 11.894 9.0776 12.2841 9.22836 12.6481C9.37913 13.012 9.6001 13.3427 9.87868 13.6213C10.1573 13.8999 10.488 14.1209 10.8519 14.2716C11.2159 14.4224 11.606 14.5 12 14.5C12.7956 14.5 13.5587 14.1839 14.1213 13.6213C14.6839 13.0587 15 12.2956 15 11.5C15 10.7044 14.6839 9.94129 14.1213 9.37868C13.5587 8.81607 12.7956 8.5 12 8.5Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGroup, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Group.af98fcb5.svg";
export { ForwardRef as ReactComponent };